const randomGifs = [
  {
    '_id': '5da23754845fd2cb76d59f10',
    'gifLink': 'https://media.tenor.com/images/7511947a6ae9acb62c9515bfba14b1ec/tenor.gif'
  },
  {
    '_id': '5da23754845fd2cb76d59f05',
    'gifLink': 'https://media.tenor.com/images/369dabafda46a71e9fdea7ff6d89fc6d/tenor.gif'
  }
];

export default randomGifs;
